import { Alert, Checkbox, Divider, Select } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import React, { useContext } from 'react';
import { ApplicationUIContext, Form } from 'ui-library';
import { validIncentiveStatus } from './common/IncentiveStatus';
import AssociationGroups from './Sections/AssociationGroups';
import Benefits from './Sections/Benefits';
import Inventory from './Sections/Inventory';
import Name from './Sections/Name';
import ValidLeaseTerms from './Sections/ValidLeaseTerms';

const IncentiveForm = ({
  form,
  onFinish,
  onFinishFailed,
  isError,
  initialValues = {},
  disabled = false,
}) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <Form
      form={form}
      size={isMobile && 'large'}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      initialValues={initialValues}
      disabled={disabled}
    >
      {isError && <Alert type="error" message={getTranslatedString('errorsOnThisPage')} showIcon />}

      <Name />

      <Divider />

      <Benefits />

      <Divider />

      <Inventory />

      <Divider />

      <AssociationGroups />

      <Divider />

      <ValidLeaseTerms />

      <Form.Item name="status" hidden>
        <Select
          options={validIncentiveStatus.map((validStatus) => ({
            label: validStatus,
            value: validStatus,
          }))}
        />
      </Form.Item>
    </Form>
  );
};

export default IncentiveForm;
